import React, {
  useState,
  useMemo,
  useCallback,
  useEffect,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import * as PR from "../../prime-modules/index";
import AdminFooter from "../layout/admin-footer.jsx";
import AdminHeader from "../layout/admin-header.jsx";
import { globalConfig } from "../../GlobalConfig";
import * as Yup from "yup";
import {
  getBatchList,
  shareEmail,
  getBatchInfo,
  createBatch,
  getPriceFilters,
  getCatalogsList,
  getCountriesList,
  updateBatch,
  modifyPromoCode,
  getAffiliateUsersList,
} from "../../services/api.jsx";
import moment from "moment";
import { useFormik } from "formik";
import * as utils from "../../utils";
import RoamingColumn from "./RoamingInfo.jsx";
import { formatPromoCode, filterCountryName, setDataAmount } from "../../utils/reuse.js";
import "./PrepaidRetailVouchers.scss";
import { getCurrentTimestamp } from "../../utils/reuse.js";
import { PERMISSIONS, hasPermission } from "../../utils/permissions";

const PrepaidRetailVouchers = () => {
  const appName = process.env?.REACT_APP_NAME;
  const timeStamp = getCurrentTimestamp()
  const dispatch = useDispatch();
  const adminData = useSelector((state) => state.adminAuth.adminSessionData);
  const headers = useMemo(() => {
    return { sessionid: adminData.sessionId };
  }, [adminData.sessionId]);
  const toast = useRef();

  const [expandedRows, setExpandedRows] = useState([]);
  const [visible, setVisible] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [createVoucher, setCreateVoucher] = useState(false);
  const [prepaidList, setPrepaidList] = useState([]);
  const [selectedBundles, setSelectedBundles] = useState([]);
  const [provider, setProvider] = useState("");
  const [filterprovider, setFilterProvider] = useState("");

  const [uniqueRegions, setUniqueRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);

  const [allCountries, setAllCountries] = useState([]);
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("");

  const [filterSelectedRegion, setFilterSelectedRegion] = useState(null);
  const [filterCountries, setFilterCountries] = useState([]);
  const [filterCountry, setFilterCountry] = useState("");

  const [displayBundle, setDisplayBundle] = useState(false);

  const [filters, setFilters] = useState({});
  const [createFilters, setCreateFilters] = useState({});

  const [batchOptions, setBatchOptions] = useState([]);

  const [bundles, setBundles] = useState([]);

  const [totalVouchers, setTotalVouchers] = useState(null);

  const [filterBatchName, setFilterBatchName] = useState(null);
  const [filterStatus, setFilterStatus] = useState("");

  const [loading, setLoading] = useState(true);
  const [catalogLoading, setCatalogLoading] = useState(false)
  const [createLoading, setCreateLoading] = useState(false)
  const [batchLoading, setBatchLoading] = useState(false)

  const [getBatchName, setGetBatchName] = useState("");
  const [getStatus, setGetStatus] = useState("");
  const [corpAffName, setCorpAffName] = useState("");
  const [globalCountries, setGlobalCountries] = useState([]);
  const [globalCountry, setGlobalCountry] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [filterCount, setFilterCount] = useState(0);

  const [selectedInfoBatch, setSelectedInfoBatch] = useState(null);
  const [showBatchInfoDialog, setShowBatchInfoDialog] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(true);
  const itemsPerPage = 20;

  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState(-1);
  const [offset, setOffset] = useState(0)

  const [disable, setDisable] = useState(false)
  const [disableText, setDisableText] = useState("")
  const [batchData, setBatchData] = useState([])
  const [error, setError] = useState("");
  const [touched, setTouched] = useState(false);
  const [paginationState, setPaginationState] = useState({});

  const [filterOpen, setFilterOpen] = useState(false);
  const toggleFilter = () => setFilterOpen(!filterOpen);
  const [affiliateNames, setAffiliateNames] = useState([]);
  const [corporateAffiliateNames, setCorporateAffiliateNames] = useState([]);
  const [createdByInfo, setCreatedByInfo] = useState(null);
  const [createdByError, setCreatedByError] = useState("");
  const [createSortField, setCreateSortField] = useState('providerPrice')
  const [createSortOrder, setCreateSortOrder] = useState(1)


  const [shareVoucher, setShareVoucher] = useState(false);
  const [voucherCode, setVoucherCode] = useState({code: "", id:""});

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isLoading,setIsLoading] = useState(false)

  const handleExportCSV = (rowData) => {
    if (!rowData?.vouchers || rowData?.vouchers?.length === 0) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Warning',
        detail: 'No vouchers available to export',
      });
      return;
    }

    const vouchers = rowData.vouchers.map((voucher) => ({
      BatchName: rowData?.batchName,
      Description: voucher?.description ? voucher?.description : '-',
      BundleID: voucher?.providerid ? voucher?.providerid : '-',
      Data: setDataAmount(voucher),
      Duration: voucher?.duration ? `${voucher?.duration} days` : '-',
      Price: voucher?.ourPrice ? `${globalConfig.defaultCurrency} ${voucher?.ourPrice}` : '-',
      Provider: voucher?.providerName ? voucher?.providerName : '-',
      Status: voucher?.vouchersnapshot?.status === 'USED' ? 'REDEEMED' : voucher?.vouchersnapshot?.status,
      VoucherCode: formatPromoCode(voucher?.vouchersnapshot?.promoCode),
      RedeemedBy: 
      Array.isArray(voucher?.vouchersnapshot?.redeemedBy) && 
        voucher.vouchersnapshot.redeemedBy[0]
          ? voucher.vouchersnapshot.redeemedBy[0].trim()
          : "-",
      CreatedByAffiliate: rowData?.ownerName
    }));

    if (vouchers.length > 0) {
      const csvContent =
        'data:text/csv;charset=utf-8,' +
        ['Batch Name', 'Description', 'Bundle ID', 'Data', 'Duration', 'Price', 'Provider', 'Status', 'Voucher Code',"Redeemed By", "Createdby Affiliate"].join(',') +
        '\n' +
        vouchers
          .map((entry) =>
            Object.values(entry)
              .map((value) => (typeof value === 'string' && value.includes(',') ? `"${value}"` : value))
              .join(',')
          )
          .join('\n');

      const encodedUri = encodeURI(csvContent);

      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', `bo.${appName}-${rowData?.batchName}-prepaid-vouchers-${timeStamp}.csv`);
      document.body.appendChild(link);
      link.click();
    }
  };

  const onPageChanges = (event, batchName) => {
    setPaginationState((prev) => ({
      ...prev,
      [batchName]: event.page,
    }));
  };

  const batchName = (rowData) => {    
    const isRedeemed = rowData.disabled !== 0 || rowData.redeemed > 0
    const isDisabled = rowData.disabled !== 0;
    const exportDisabled = rowData.vouchers.length < 1
    return (
      <div className="batch-column" onClick={(e) => e.stopPropagation()}>
        <div className="card flex align-items-center gap-2">
          <p>
            {rowData?.batchName}{" "}
          </p>
            {hasPermission(adminData.permission, PERMISSIONS.MANAGE_PROMOS) && (
              <span 
              onClick={() => !isRedeemed && updateBatchDisable(rowData, "reserve", "res")} 
              title={isRedeemed ? "Disabled":rowData?.reserved === rowData?.total? "Mark as unreserved": "Mark as reserved"} 
              className={`hourglass-icon ${ rowData?.reserved === rowData?.total && !isDisabled ? 'bg-red-500' : "reserved"}` }>
                <i className={`pi pi-hourglass ${(isDisabled || isRedeemed) ? "text-gray-300":"redeemed"}`}/>
              </span>
            )}
          <i
            title={ isDisabled ? "Disabled": "View Details"}
            className={`pi pi-info-circle ${isDisabled ? "text-gray-300":""}`  }  
            style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
            onClick={() => !isDisabled && handleBatchInfoClick(rowData)}
          ></i>
          <i
            className={`pi pi-file ${(isDisabled || exportDisabled) ? "text-gray-300":""}`}
            title={ isDisabled ? "Disabled":"Export CSV"}
            style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
            onClick={() => { if (!isDisabled && !exportDisabled) { handleExportCSV(rowData)}}}
          ></i>
        </div>
        {rowData?.ownerName?.trim() ?
          <span className="affiliate-name">Created by Affiliate: <strong> {rowData?.ownerName} </strong> </span>
          : ""
        }
      </div>
    );
  };

  const handleOrderDetails = (orderId) => {
    if (orderId && orderId !== null) {
      // Redirecting to new tab (Order detail screen)
      window.open(`/orders/details/${orderId}`, "_blank");
    }
  }

  const updatePromocode = (values, promoCode) => {
    setLoading(true)
    const isCurrentlyReserved = values.reserved === true;
        const getResponse = response => {
            setLoading(false);
          if (response.result === "SUCCESS") {
               if(isCurrentlyReserved){
                values.reserved = false
                values.status = "ACTIVE"
               }else{
                values.reserved = true
                values.status = "RESERVED"
                copyToClipboard(formatPromoCode(promoCode), false)
               }
                toast.current.show({ severity: 'success', summary: isCurrentlyReserved ? `Voucher unreserved successfully` : `Voucher reserved and copied successfully` });
            } else {
                setLoading(false);
                const error = response.error;
                toast.current?.show({
                  severity: error.severity,
                  summary: "Error",
                  detail: error?.errorMsg ? error?.errorMsg : error?.summary,
                });
            }
        }
        const updateRequestObj = {
            id: +values.id,
            promoCode: values.promoCode,
            reserved: !isCurrentlyReserved,
            discountType: 'prepaidbundle'
        }
        modifyPromoCode(updateRequestObj, headers, dispatch, getResponse);
  }

  const rowExpansionTemplate = (rowData) => {
    const vouchers = rowData?.vouchers; // Get vouchers excluding the first one (shown in main row)
    const rowsPerPage = 10;
    const startIndex = (paginationState[rowData.batchName] || 0) * rowsPerPage;
    const displayedVouchers = rowData.vouchers.slice(startIndex, startIndex + rowsPerPage);

    const renderVoucherStatus = (voucher) => {
      const voucherStatus = voucher?.vouchersnapshot?.status;
      if (!voucherStatus || voucherStatus?.length === 0) {
        return <span className="status expired">N/A</span>; // Handle cases where there are no vouchers
      }
      switch (voucherStatus.toLowerCase()) {
        case "published":
          return <span className="status published">Published</span>;
        case "active":
          return <span className="status active">Active</span>;
        case "reserved":
          return <span className="status pending">Reserved</span>;
        case "pending":
          return <span className="status pending">Pending</span>;
        case "expired":
          return <span className="status expired">Expired</span>;
        case "used":
          return <span className="status redeemed">Redeemed</span>;
        case "invalid":
          return <span className="status expired">Invalid</span>;
        default:
          return <span className="status none">Unknown Status</span>;
      }
    };

    return (
      <div>
        {vouchers && vouchers?.length > 0 ? (
          <PR.DataTable
            value={displayedVouchers}
            stripedRows
            className="vouchers-expandable-table"
            rowClassName={(rowData) => {
              let className = "";
              if (rowData?.vouchersnapshot?.disabled === true) {
                className += "disabled-row ";
              }
              return className.trim();
            }}
          >
            {/* Render shared bundle details */}
            <PR.Column header="" style={{ width: "3%" }} />
            <PR.Column
              header=""
              style={{ width: "22%" }}
              className="batch-column"
            />
            <PR.Column
              header="Plan"
              body={(e) => e?.description ? filterCountryName(e?.description) : "-"}
              style={{ width: "15%" }}
            />
             <PR.Column
              field="providerid"
              header="Bundle ID"
              style={{width:"13%"}}
              body={(e) => (
                e?.providerid ?
                  e?.providerid : '-'
              )}
            />   
            <PR.Column
              header="Duration"
              body={(e) => (e.duration ? `${e.duration} days` : "-")}
              style={{ width: "8%" }}
              bodyClassName="duration-td"
            />
            <PR.Column
              header="Data"
              body={(e) => setDataAmount(e)}
              style={{ width: "8%" }}
            />
            <PR.Column
              header="Price"
              body={(e) =>
                e.ourPrice ? `${globalConfig.defaultCurrency} ${e.ourPrice}` : "-"
              }
              style={{ width: "7%" }}
            />

            <PR.Column
              header="Status"
              body={(voucher) => renderVoucherStatus(voucher)}
              style={{ width: "8%" }}
            />
            <PR.Column
              header="Voucher Code"
              className="voucherCode"
              field="promoCode"
              body={(rowData) => {
                let disableCode = rowData?.vouchersnapshot?.status === "RESERVED"
                return(
                <div className="voucherCode">
                { disableCode ? <span>XXXX-XXXX-XXXX</span> : <span>{formatPromoCode(rowData?.vouchersnapshot?.promoCode) || 'N/A'}</span>}
                  <div className="voucher-action-btns">
                    {hasPermission(adminData.permission, PERMISSIONS.MANAGE_PROMOS) && (
                      <span   onClick={() =>
                            rowData?.vouchersnapshot?.status !== 'USED' &&
                            updatePromocode(rowData?.vouchersnapshot, rowData?.vouchersnapshot?.promoCode)
                          } title={
                            rowData?.vouchersnapshot?.status !== 'USED'
                              ? rowData?.vouchersnapshot?.reserved
                                ? "Mark as unreserved"
                                : "Mark as reserved"
                              : null 
                          }  className={`hourglass-icon ${rowData?.vouchersnapshot?.status === 'USED' ? 'icon-redeemed' : rowData?.vouchersnapshot?.reserved ? 'icon-reserved' : null}`}>
                        <i      
                          className="pi pi-hourglass"
                        />
                      </span>
                    )}
                    
                  {disableCode ? <i
                      className="pi pi-copy"
                      style={{
                        color: 'gray',
                        marginRight: '8px',
                      }}
                      onClick={() => {}}
                    />  
                      : <i
                      title="Copy Voucher Code"
                      className="pi pi-copy"
                      style={{
                        color: 'red',
                        marginRight: '8px',
                        cursor: 'pointer'
                      }}
                      onClick={() => copyToClipboard(formatPromoCode(rowData?.vouchersnapshot?.promoCode), true)}
                    />}
                      {rowData?.vouchersnapshot?.status !== "USED" && 
          <span className={`send-icon ${rowData?.vouchersnapshot?.reserved ? "disabled" : ""}`}
            title="Share Voucher Code" 
            onClick={() => { setShareVoucher(true); setVoucherCode({code : formatPromoCode(rowData?.vouchersnapshot?.promoCode), id: rowData?.vouchersnapshot?.id }) }}>
          </span>
        }
                  </div>
                </div>
              )}}
              style={{ width: "13.3%" }}
            />
            <PR.Column
              body={({ vouchersnapshot, orderids }) => (
                vouchersnapshot?.status === "USED" && orderids !== null ? (
                  <div className="flex align-items-center">
                    <span className="details-btn">
                      <i
                        className="pi pi-chevron-right"
                        onClick={() => handleOrderDetails(orderids[0])}
                      />
                    </span>
                  </div>
                ) : null // Return null instead of empty fragment
              )}
              className="last-column"
              style={{ width: "2%" }}
            />
          </PR.DataTable>
        ) : (
          <p>No additional vouchers</p>
        )}
      </div>
    );
  };

  const providerList = [
    { name: "eSIM-Go" },
    { name: "Airalo" },
    { name: "Cobira" },
    { name: "Uk Domestic" }
  ];


  const handleBatchInfoClick = (rowData) => {
    const req = {
      id: rowData?.batchName,
      status: rowData?.vouchers[0]?.vouchersnapshot?.status,
    };
    getBatchInfo(req, headers, dispatch, (response) => {
      if (response.result === "SUCCESS") {
        setSelectedInfoBatch(response.data);
        setShowBatchInfoDialog(true);
        setDisableText(rowData?.vouchers[0]?.vouchersnapshot?.disabled === true ? 'Enable Batch' : 'Disable Batch')
        const ownerName = rowData?.vouchers[0]?.ownerName;
        const matched = affiliateNames.find(a => a.name.trim() === ownerName?.trim());
  
        if (matched) {
          setCreatedByInfo(matched.id);
        } else {
          setCreatedByInfo(null);
        }      
      } else {
        const error = response?.error;
        toast.current?.show({
          severity: error.severity,
          summary: "Error",
          detail: error?.errorMsg ? error?.errorMsg : error?.summary,
        });
      }
    });
  };
  
  const onSortChange = (field) => {
    const newSortOrder = sortField === field && sortOrder === 1 ? -1 : 1;
    setSortField(field);
    setSortOrder(newSortOrder);
    getBatch(field, newSortOrder === 1 ? 'asc' : 'desc');
    setExpandedRows([])
  }

  const handleSubmit = (values, { setSubmitting }) => {
    setCreateLoading(true)
    if (!totalVouchers) {
      setError("Voucher count is required");
    } else {
      setError("");
    }
    const currentDate = new Date();
    const endDate = new Date();
    endDate.setFullYear(currentDate.getFullYear() + 3);
    const formData = {
      discountType: "prepaidbundle",
      ...values,
      startTs: currentDate.toISOString(),
      endTs: endDate.toISOString(),
      discounts: selectedBundles,
      maxNrOfUses: 1,
    };
    const totalSelectedCounts = selectedBundles?.reduce((sum, b) => sum + (b.count || 0), 0);
    if (totalSelectedCounts !== totalVouchers) {
      toast.current.show({ 
        severity: 'warn', 
        summary: 'Total mismatch', 
        detail: 'Total voucher count does not match selected vouchers.', 
        life: 3000 
      });
      setSubmitting(false);
      setCreateLoading(false)
      return;
    }
    // searchHandler(values);
    setSubmitting(false);
      const getResponse = (response) => {
      setCreateLoading(false)
      if (response.result === "SUCCESS") {
        setCreateVoucher(false);
        getBatch()
        formik.resetForm()
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Created Batch successfully",
        });
      } else {
        const error = response.error;
        setCreateLoading(false)
        toast.current.show({
          severity: error.severity,
          summary: "Error",
          detail: error.errorMsg ? error.errorMsg : error.summary,
        });
      }
      resetData();
    };
    createBatch(formData, headers, dispatch, getResponse);
  }

  const getBatch = useCallback(async (sortField = 'createdAt', sortOrder = 'desc') => {
    setLoading(true);
    const defaultFilters = {
      offset: offset,
      limit: itemsPerPage,
      orderBy: sortField,
      direction: sortOrder,
      country: globalCountry
    };
    const queryParams = utils.serializeParams({
      ...filters,
      ...defaultFilters,
    });
    let getResponse = (response) => {
      setLoading(false);
      if (response.result === "SUCCESS") {
        const promoCodes = response.data ? response.data : [];
        const promoCodesList = promoCodes.filter(p => (p.name !== '' && p.bundles.length !== 0))
        setTotalRecords(promoCodes.length === itemsPerPage);
        if (promoCodesList.length > 0) {
          setPrepaidList(promoCodesList);
          if (!queryParams.includes('batchId')) {
            const batchOptions = promoCodesList.map((item) => ({
              name: item.name,
              value: item.name,
            }))

            setBatchOptions(batchOptions);
          }

        } else {
          setLoading(false);
          toast.current.show({
            severity: "warn",
            summary: "Warning",
            detail: "No records found",
          });
          setPrepaidList([])
        }
      } else {
        setPrepaidList([]);
        setLoading(false);
        const error = response.error;
        toast.current?.show({
          severity: error.severity,
          summary: "Error",
          detail: error.errorMsg ? error.errorMsg : error.summary,
        });
      }
    };
    getBatchList(queryParams, headers, dispatch, getResponse);
  }, [offset, globalCountry, filters, headers, dispatch]);

  useEffect(() => {
    getBatch();
  }, [getBatch]);

  const getCatalogs = useCallback(async (sortBy = "providerPrice", sortDirection = "asc") => {
    setCatalogLoading(true);
    const defaultFilters = {
      sortingOrder: sortDirection,
      orderBy: sortBy,
      country,
    };
    const queryParams = utils.serializeParams({
      ...createFilters,
      ...defaultFilters,
    });
    const handleResponse = (response) => {
      setCatalogLoading(false);
      if (response.result === "SUCCESS") {
        let catalogList = response.data || [];
        catalogList = catalogList?.filter(c => c.ourPrice !== -1)
        if (Array.isArray(catalogList) && catalogList?.length > 0) {
          setBundles(catalogList);
          setDisplayBundle(true);
        } else {
          setBundles([]);
          toast.current.show({
            severity: "warn",
            summary: "Warning",
            detail: "No plans for the selected",
          });
        }
      } else {
        setBundles([]);
        const error = response?.error;
        toast.current?.show({
          severity: error.severity,
          summary: "Error",
          detail: error?.errorMsg || error?.summary,
        });
      }
    };
    getCatalogsList(queryParams, headers, dispatch, handleResponse);
  }, [createFilters, country, headers, dispatch]);

  // useEffect(() => {
  //   getCatalogs()
  // }, [getCatalogs]);

  const searchHandler = useCallback(() => {
    setCreateFilters((prevFilters) => ({
      ...prevFilters,
      country,
      region: selectedRegion,
      providerName: provider ? provider.map((item) => item?.name).join(",") : "",
    }));
    getPriceFilters(headers, dispatch, (response) => {
      if (response.result === "SUCCESS") {
      } else {
        const error = response?.error;
        toast.current?.show({
          severity: error.severity,
          summary: "Error",
          detail: error?.errorMsg ? error?.errorMsg : error?.summary,
        });
      }
    });
  }, [country, selectedRegion, provider, dispatch, headers]);

  const getSearchHandler = useCallback(() => {
    const searchStatus = getStatus?.length ? getStatus.join(",") : null;
    setOffset(0)
    setCurrentPage(1)
    setFilters((prevFilters) => ({
      ...prevFilters,
      batchId: getBatchName,
      status: searchStatus,
      owner: corpAffName,
      country: globalCountry,
      keyword: searchValue ? searchValue.trim() : null,
    }));
  }, [getBatchName, getStatus, corpAffName, globalCountry, searchValue]);

  useEffect(() => {
    if (
      createFilters.country ||
      createFilters.region ||
      createFilters.provider
    ) {
      getCatalogs();
    }
  }, [createFilters, getCatalogs, headers, dispatch]);

  useEffect(() => {
    const handleCountriesResponse = (response) => {
      if (response.result === "SUCCESS") {
        const countriesData = response.data || [];
        if (countriesData.length > 0) {
          const countriesList = countriesData.map(({ name, region, iso }) => ({
            name: name.split("(")[0].trim(),
            region,
            iso,
          }));
          setAllCountries(countriesList);
          setCountries(countriesList);
          setFilterCountries(countriesList);
          setGlobalCountries(countriesList)
          const uniqueRegionList = [
            ...new Set(countriesList.map((item) => item.region)),
          ].map((region) => ({ label: region, value: region }));
          const unemptyRegionList = uniqueRegionList
            ?.filter((region) => region.label && region.value)
            .sort((a, b) => a.label.localeCompare(b.label)); // Removed empty object from the region list
          setUniqueRegions(unemptyRegionList);
        }
      }
    };
    getCountriesList(headers, dispatch, handleCountriesResponse);
  }, [dispatch, headers]);

  const handleBundleSelection = (bundle, isChecked) => {
    const bundleKey = bundle?.name || bundle?.providerBundleName || bundle?.discountBundle;
    if (!bundleKey) return;
    setSelectedBundles((prev) => {
      const exists = prev.some((b) => b.discountBundle === bundleKey || (bundle?.name && b.discountBundle === bundle.name));
      if (isChecked) {
        if (exists) return prev;
        return [...prev, { discountBundle: bundleKey, count: null }];
      } else {
        return prev.filter((b) => b.discountBundle !== bundleKey && b.discountBundle !== bundle?.name);
      }
    });
  };

  const displayedBundles = useMemo(() => {
    return bundles
      ?.filter((bundle) => bundle?.offered === true)
      ?.map((bundle) => {
        const bundleKey = bundle?.name || bundle?.providerBundleName || bundle?.discountBundle;
        const isSelected =
          Array.isArray(selectedBundles) &&
          selectedBundles?.some(
            (selected) =>
              selected?.discountBundle === bundleKey ||
              (bundle?.name && selected?.discountBundle === bundle?.name)
          );
        return {
          ...bundle,
          _isSelected: Boolean(isSelected),
        };
      });
  }, [bundles, selectedBundles]);

  const selectBox = (bundle) => {
    const isSelected = Boolean(bundle?._isSelected);
    return (
      <PR.Checkbox
        checked={isSelected}
        onChange={() => handleBundleSelection(bundle, !isSelected)}
      />
    );
  };

  const globalSearchHandler = (e) => {
    setSearchValue(e.target.value);
  };

  const handleRegionSelection = (region) => {
    setSelectedRegion(region);
    setFilterSelectedRegion(region);
    const countriesByRegion = region
      ? allCountries?.filter((c) => c.region === region)
      : allCountries;
    setCountries(countriesByRegion);
    setFilterCountries(countriesByRegion);
    const countryDisplay = countriesByRegion?.find((c) => c.iso === country)
      ? country
      : null;
    setCountry(region ? countryDisplay : "");
    setSelectedBundles([]);
    if (!region) {
      setBundles([]);
      setDisplayBundle(false);
      setCreateFilters({});
    }
  };

  const handleCountrySelection = (e) => {
    const selectedCountry = e?.value || "";
    setCountry(selectedCountry);
    setFilterCountry(selectedCountry);
    setSelectedBundles([]);
    if (!selectedCountry && !selectedRegion && (!provider || provider.length === 0)) {
      setBundles([]);
      setDisplayBundle(false);
      setCreateFilters({});
    }
  };

  const regionFilterHandler = (region) => {
    setFilterSelectedRegion(region);
    const countriesByRegion = region
      ? allCountries?.filter((c) => c.region === region)
      : allCountries;
    const countryDisplay = countriesByRegion?.find(
      (c) => c.iso === filterCountry
    )
      ? filterCountry
      : null;
    setFilterCountry(region ? countryDisplay : "");
    setFilterCountries(countriesByRegion);
  };

  const countryFilterHandler = (e) => {
    setFilterCountry(e.value);
  };

  const handleProviderSelection = (e) => {
    const selectedProviders = e?.value || [];
    setProvider(selectedProviders);
    setSelectedBundles([]);
    if (selectedProviders.length === 0 && !selectedRegion && !country) {
      setBundles([]);
      setDisplayBundle(false);
      setCreateFilters({});
    }
  };

  const handleProviderFilterSelection = (e) => {
    setFilterProvider(e.value);
  };

  const handleVoucherChange = (bundle, newCount) => {
    setSelectedBundles((prev) => {
      const updatedBundles = prev.map((b) =>
        b?.discountBundle === bundle?.name ? { ...b, count: newCount } : b
      );
      return updatedBundles;
    });
  };

  const vouchersInput = (bundle) => {
    const selectedBundle = selectedBundles?.find(
      (b) => b?.discountBundle === bundle?.name
    );
    const currentCount = selectedBundle ? selectedBundle?.count : null;
    return (
      <div>
        <PR.InputNumber
          value={currentCount} // Show the current voucher count
          onChange={(e) => {
            let newValue = e.value;
            if(newValue === 0) {
              handleVoucherChange(bundle, 1)
            } else if (/^\d*$/.test(newValue)) {
              if (newValue.length > 4) {
                newValue = newValue.slice(0, 4)
              }
            const newCount = parseInt(newValue, 10);
            if (!isNaN(newCount) && newCount <= 9999) {
              handleVoucherChange(bundle, newCount);
            } else if (newValue === "") {
              handleVoucherChange(bundle, null);
              }
            }
          }}
          disabled={!selectedBundle}
          min={1}
          maxLength={4}
        />
      </div>
    );
  };

  const flattenBundles = (list) => {
    return list.map((batch) => ({
      batchName: batch?.name, // Batch name
      id: batch?.bundles.map((bundles) => bundles?.bundle.id),
      redeemed: batch?.redeemed,
      reserved: batch?.reserved,
      disabled: batch?.disabled,
      total: batch?.total,
      createdAt: batch?.createdAt,
      description: batch?.bundles.map((bundles) => bundles?.bundle?.description),
      providerid: batch?.bundles.map((bundles) => bundles?.bundle?.providerid),
      duration: batch?.bundles.map((bundles) => bundles?.bundle?.duration),
      dataAmount: batch?.bundles.map((bundles) => bundles?.bundle?.dataAmount),
      ourPrice: batch?.bundles.map((bundles) => bundles?.bundle?.ourPrice),
      // status: batch?.status,
      vouchers: batch?.bundles?.flatMap((bundle) =>
        bundle?.vouchers.map((i) => ({
          ...i,
          name: bundle?.bundle?.name,
          description: bundle?.bundle?.description,
          ourPrice: bundle?.bundle?.ourPrice,
          dataAmount: bundle?.bundle?.dataAmount,
          duration: bundle?.bundle?.duration,
          providerName: bundle?.providerName,
          providerid: bundle?.bundle?.providerid,
        }))
      ), // Keep vouchers for expansion
      promoCode: batch?.bundles[0]?.vouchers?.[0]?.promoCode || "N/A",
      ownerName: batch?.bundles[0]?.vouchers?.[0]?.ownerName || ""
    }));
  };

  const flattenedList = flattenBundles(prepaidList);

  const handleTotalVoucherChange = (e) => {
    const value = e.value;
      if (value === 0) {
      setTotalVouchers(1);
    } 
    else if (value > 0 && value <= 9999) {
      setTotalVouchers(value);
    } 
    else if (value === null) {
      setTotalVouchers(null);
    }
  };
  
  const copyToClipboard = (voucherCode, showToast) => {
    navigator.clipboard.writeText(voucherCode);
    if (showToast) {
    toast.current.show({
      severity: 'success',
      summary: 'Copied',
      detail: `Voucher code copied to clipboard!`,
      life: 3000,
    });
  }
  };

  const getResetHandler = () => {
    setFilters({ batchName: null, status: null, keyword: null });
    setGetBatchName("");
    setGetStatus("");
    setCorpAffName("")
    setSearchValue("");
    setGlobalCountries(allCountries);
    setGlobalCountry("");
  };

  const resetData = () => {
    setSelectedRegion(null);
    setCountries(allCountries);
    setCountry("");
    setFilterSelectedRegion(null);
    setCreateFilters([]);
    handleFilterReset();
    setProvider([]);
    setBundles([]);
    setTotalVouchers(null);
    setDisplayBundle(false);
    setSelectedBundles([]);
    formik.resetForm({
      values: {
        batchName: "",
      },
      errors: {},
      touched: {},
    });
  };

  const handleFilterReset = () => {
    setFilterSelectedRegion(null);
    setFilterCountries(allCountries);
    setFilterCountry("");
    setFilterBatchName(null);
    setFilterStatus("");
    setFilterProvider("");
    setStartDate(null);
    setEndDate(null);
    setFilterCount(0);
    setOffset(0);
    setCurrentPage(1)
    setVisible(false)
    setFilters({})
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setVisible(false);
    setCountries(filterCountries);
    const countryDisplay = filterCountries?.find((c) => c.iso === filterCountry)
      ? filterCountry
      : null;
    setCountry(countryDisplay);
    setSelectedRegion(filterSelectedRegion);
    const createdTimeStart =
      Array.isArray(startDate) && startDate[0]
        ? moment(startDate[0]).format("DD-MM-YYYY")
        : null;

    const createdTimeEnd =
      Array.isArray(startDate) && (startDate[1] || startDate[0])
        ? moment(startDate[1] || startDate[0]).format("DD-MM-YYYY")
        : null;

    const redeemTimeStart =
      Array.isArray(endDate) && endDate[0]
        ? moment(endDate[0]).format("DD-MM-YYYY")
        : null;

    const redeemTimeEnd =
      Array.isArray(endDate) && (endDate[1] || endDate[0])
        ? moment(endDate[1] | endDate[0]).format("DD-MM-YYYY")
        : null;
    const newFilters = {
      region: filterSelectedRegion,
      country: filterCountry,
      provider: filterprovider
        ? filterprovider.map((provider) => provider.name).join(",")
        : "",
      batchId: filterBatchName,
      createdTimeStart,
      createdTimeEnd,
      redeemTimeStart,
      redeemTimeEnd,
      status: filterStatus,
    };
    setFilters((prev) => ({ ...prev, ...newFilters }));
    setFilterCount(getAppliedFiltersCount());
    setOffset(0)
    setCurrentPage(1)
  };

  const getAppliedFiltersCount = () => {
    let count = 0;
       
    if (Array.isArray(filterprovider) && filterprovider.length > 0) {
      count += filterprovider.length;
    }
    if (filterSelectedRegion) count++;
    if (filterCountry) count++;          
    if (filterBatchName) count++;         
    if (startDate !== null) count++;
    if (endDate !== null) count++;
    if (filterStatus.length > 0) count++;                                   
    return count;
  };

  const onHideHandler = () => {
    setBundles([])
    setCreateVoucher(false)
    formik.resetForm()
    setSelectedRegion('')
    setCountry('')
    setProvider('')
    setTotalVouchers(null)
    setSelectedBundles([])
    setTouched(false)
    setError("")
  }

  const optionStatusList = [
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "PENDING", value: "PENDING" },
    { label: "EXPIRED", value: "EXPIRED" },
    { label: "REDEEMED", value: "USED" },
    { label: "INVALID", value: "INVALID" },
  ];

  const handleFormSubmit = (e) => {
    getResetHandler()
    e.preventDefault();
    // Check if any selected bundle has a count of 0
    const hasInvalidVoucherCount = selectedBundles?.some(
      (bundle) => bundle?.count === null
    );

    if (hasInvalidVoucherCount) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Voucher count cannot be 0 in selected bundles",
      });
      return; // Prevent API call
    }
    formik.handleSubmit();
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      const newOffset = (newPage - 1) * itemsPerPage;
      setOffset(newOffset)
    }
  };

  const handleNextPage = () => {
    const newPage = currentPage + 1;
    setCurrentPage(newPage);
    const newOffset = (newPage - 1) * itemsPerPage;
    setOffset(newOffset)
  };

  const getAllAffiliateUsers = useCallback(async () => {
      const sortOrderVal = (sortOrder === 1) ? "asc" : "desc";
      const obj = {
          offset: 0,
          limit: 1000,
          sortField: sortField,
          sortOrder: sortOrderVal,
          name: "",
          affiliateName: "",
          email: "",
          phone: "",
          isActive: "",
          createdDateFrom: "",
          createdDateTo: "",
      };
      getAffiliateUsersList(obj, headers, dispatch, response => {
          if (response.result === 'SUCCESS') {
              const list = response.data;
              const affiliateName = list.map(affName => affName)
              setAffiliateNames(affiliateName)
          }
      })
  }, [ sortOrder, sortField, headers, dispatch])

  const getCorporateAffiliateUsers = useCallback(async () => {
      const sortOrderVal = (sortOrder === 1) ? "asc" : "desc";
      const obj = {
          offset: 0,
          limit: 1000,
          sortField: sortField,
          sortOrder: sortOrderVal,
          name: "",
          affiliateName: "",
          email: "",
          phone: "",
          isActive: "",
          createdDateFrom: "",
          createdDateTo: "",
          type: 1 // Corporate affiliate
      };
      getAffiliateUsersList(obj, headers, dispatch, response => {
          if (response.result === 'SUCCESS') {
              const list = response.data;
              const affiliateName = list.map(item => ({
                name: item.name,
                value: item.id 
              }));              
              setCorporateAffiliateNames(affiliateName)
          }
    })
}, [ sortOrder, sortField, headers, dispatch])

  useEffect(() => {
      getAllAffiliateUsers()
      getCorporateAffiliateUsers()
  }, [getAllAffiliateUsers, getCorporateAffiliateUsers]);

  const updateBatchDisable = (rowData, actionType, screen) => {
    let batchId = "";
    if (actionType === "reserve" || screen === "main") {
      batchId = rowData?.batchName;
    } else if (actionType === "disable" && screen !== "main") {
      batchId = rowData?.name;
    } else {
      batchId = rowData?.name
    }
  
    const voucherUpdate = {
      note: "",
    };
  
    if (actionType === "reserve") {
      voucherUpdate.reserved = rowData?.reserved === rowData?.total ? false : true;
    }
  
    if (actionType === "disable") {
      const isDisabled = disableText === "Enable Batch" ? false : true;
      voucherUpdate.disabled = isDisabled;
      voucherUpdate.discountType = "prepaidbundle";
    }
  
    const payload = {
      voucherUpdate,
      batchId,
      owner: createdByInfo || null,
    };
  
    setBatchLoading(true);
  
    updateBatch(payload, headers, dispatch, (response) => {
      setBatchLoading(false);
  
      if (response.result === "SUCCESS") {
        setDisable(false);
        setShowBatchInfoDialog(false);
  
        if (actionType === "disable") {
          const isNowDisabled = payload.voucherUpdate.disabled;
          setDisableText(isNowDisabled ? "Enable Batch" : "Disable Batch");
        }
  
        const reserved = payload.voucherUpdate.reserved;
        const disabled = payload.voucherUpdate.disabled;
  
        let detail = "";
        if (actionType === "reserve") {
          detail = `Batch successfully ${reserved ? "reserved" : "unreserved"}.`;
        } else if (actionType === "disable") {
          detail = `Batch successfully ${disabled ? "disabled" : "enabled"}.`;
        } else if (actionType === "affiliate") {
          detail = `Created By updated successfully`
        }  
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail,
        });
  
        getBatch();
      } else {
        const error = response?.error || {};
        toast.current?.show({
          severity: error.severity || "error",
          summary: "Error",
          detail: error.errorMsg || error.summary || "An unknown error occurred.",
        });
      }
    });
  };
  
  const renderSortableHeader = (label, field) => {
    return (
      <div onClick={() => onSortChange(field)}>
        {label}
        <i
          className={`pi pi-sort-${sortField === field ? (sortOrder === 1 ? 'amount-up-alt' : 'amount-down') : 'alt'}`}
          style={{ marginLeft: '0.5rem' }}
        />
      </div>
    );
  };

  const downloadXls = (batch) => {
    const mappedBatch = {
      batchName: batch?.name,
      ownerName: batch?.bundles[0]?.vouchers[0]?.ownerName,
      vouchers: batch.bundles.flatMap(allBundle => 
        allBundle.vouchers.length > 0 
          ? allBundle.vouchers.map(voucher => ({
              description: allBundle?.bundle?.description,
              providerid: allBundle?.bundle?.providerid,
              dataAmount: allBundle?.bundle?.dataAmount,
              duration: allBundle?.bundle?.duration,
              ourPrice: allBundle?.bundle?.ourPrice,
              providerName: allBundle?.providerName,
              vouchersnapshot: {
                promoCode: voucher?.vouchersnapshot?.promoCode,
                status: voucher?.vouchersnapshot?.status,
                redeemedBy: voucher?.vouchersnapshot?.redeemedBy
              }
            }))
          : [{
              description: allBundle?.bundle?.description,
              providerid: allBundle?.bundle?.providerid,
              dataAmount: allBundle?.bundle?.dataAmount,
              duration: allBundle?.bundle?.duration,
              ourPrice: allBundle?.bundle?.ourPrice,
              providerName: allBundle?.providerName,
              vouchersnapshot: {
                promoCode: '', 
                status: '-'
              }
            }]
      )
    };
  
    handleExportCSV(mappedBatch);
  };

  const handleBlur = () => {
    setTouched(true); // Mark the input as touched
    if (totalVouchers === null) {
      setError("Voucher count is required");
    } else {
      setError("");
    }
  };

  const handleAffiliateOptions = (customers = []) => {
    return (Array.isArray(customers) ? customers : [])
      .map(customer => ({
        label: customer.name.trim(),
        value: customer.id
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  };  
  
  const formik = useFormik({
    initialValues: {
      batchName: "",
    },
    validationSchema: Yup.object({
      batchName: Yup.string()
        .required("Batch name is required")
        .min(3, "Batch name must be at least 3 characters")
        .max(50, "Batch name cannot exceed 50 characters")
    }),
    onSubmit: handleSubmit,
  });




  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!value.trim()) {
      return "Email is required.";
    } else if (!emailRegex.test(value)) {
      return "Please enter a valid email.";
    }
    return "";
  };

  const handleSend = () => {
   
    const error = validateEmail(email);
    if (error) {
      setEmailError(error);
      return;
    }
    setIsLoading(true)

    setEmailError("");

    const req = { email, id: voucherCode?.id };
    shareEmail(req, headers, dispatch, (response) => {
      if (response.result === "SUCCESS") {

        toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Voucher shared successfully!' });
      setShareVoucher(false);
      setEmail("");
      setEmailError("");
      setIsLoading(false)

      setPrepaidList((prev) =>
        {
          return prev.map(voucherItem => ({
            ...voucherItem,
            bundles: voucherItem.bundles.map(bundle => ({
              ...bundle,
              vouchers: bundle.vouchers.map(v => {
                if (v.vouchersnapshot.id === voucherCode.id) {
                  return {
                    ...v,
                    vouchersnapshot: {
                      ...v.vouchersnapshot,
                      reserved: 1,
                      status: "RESERVED"
                    }
                  };
                }
                return v;
              })
            }))
          }));
        }
      );
          
      } else {
        const error = response?.error;
        toast.current?.show({
          severity: error.severity,
          summary: "Error",
          detail: error?.errorMsg ? error?.errorMsg : error?.summary,
        });
        setIsLoading(false)
      }
    });
  };

  const handleHide = () => {
    setShareVoucher(false);
    setEmail("");
    setEmailError("");
  };

  // const handleBlur = () => {
  //   const error = validateEmail(email);
  //   setEmailError(error);
  // };

  const handleReset = () => {
    setEmail("");
    setEmailError("");
  };

  return (
    <>
      <div className="main">
        <div className="layout-sidebar">
          <AdminHeader />
        </div>
        <div className="layout-content-wrapper">
          <section className="admin-users-section promo-code-section">
            <div className="grid grid-nogutter">
              <div className="col-12">
                <div className="heading-sec vouchers-header">
                  <div className="flex align-items-center justify-content-between mb-4 mobile-flex">
                    <h1>Prepaid/Retail Vouchers</h1>
                    <div className="flex align-items-center justify-content-between mobile-screen-width">
                      <div className="right-section flex align-items-center gap-3">
                        {hasPermission(adminData.permission, PERMISSIONS.MANAGE_PROMOS) && (
                          <>
                            <PR.Button
                              label="Create Prepaid Voucher"
                              className="export-button"
                              icon="pi pi-plus"
                              iconPos="left"
                              onClick={() => setCreateVoucher(true)}
                              disabled={loading}
                            />
                            <PR.Button
                              label= {filterCount > 0 ? <> Filter <span className="count">{filterCount}</span></> : "Filter"}
                              className="exportBtn filter-btn"
                              icon="pi pi-filter"
                              onClick={() => setVisible(true)}
                              disabled={loading}
                            />
                          </>
                        )}
                      </div>
                      <PR.Button text className="filter-toggle-button" onClick={toggleFilter}>
                          <i className={`pi ${filterOpen ? "pi-filter-slash" : "pi-filter-fill"}`}></i>
                      </PR.Button>
                    </div>
                  </div>
                </div>
                <div className={`flex align-items-center justify-content-between filter-right retail-vouchers-filter ${filterOpen ? "mobile-filter-section" : ""}`}>
                  <div className="flex align-items-center gap-2 mobile-flex">
                    <span className="p-input-icon-right search-field">
                      <i className="pi pi-search" />
                      <PR.InputText
                        name="search"
                        placeholder="Search by Voucher code, Redeemed by email"
                        value={searchValue}
                        onChange={globalSearchHandler}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            getSearchHandler();
                          }
                        }}
                        disabled={loading}
                        className="vouchers-search"
                      />
                    </span>

                    <PR.Dropdown
                      filter
                      placeholder="Batch Name"
                      value={getBatchName}
                      options={batchOptions}
                      resetFilterOnHide
                      optionLabel="name"
                      optionValue="value"
                      name="batchName"
                      maxSelectedLabels={1}
                      onChange={(e) => setGetBatchName(e.value)}
                      disabled={loading}
                    />

                    <PR.MultiSelect
                      placeholder="Status"
                      value={getStatus}
                      options={optionStatusList}
                      optionLabel="label"
                      optionValue="value"
                      name="status"
                      maxSelectedLabels={1}
                      onChange={(e) => setGetStatus(e.value)}
                      disabled={loading}
                    />

                    <PR.Dropdown
                      filter
                      placeholder="Affiliate"
                      value={corpAffName}
                      options={corporateAffiliateNames}
                      resetFilterOnHide
                      optionLabel="name"
                      optionValue="value"
                      name="corpAffName"
                      maxSelectedLabels={1}
                      onChange={(e) => setCorpAffName(e.value)}
                      disabled={loading}
                    />

                    <PR.Dropdown
                      filter
                      placeholder="Country"
                      value={globalCountry}
                      options={globalCountries}
                      resetFilterOnHide
                      optionLabel="name"
                      optionValue="iso"
                      maxSelectedLabels={1}
                      onChange={(e) => setGlobalCountry(e.value)}
                      disabled={loading}
                      showClear={globalCountry ? true : false}
                    />

                    <PR.Button
                      type="submit"
                      label="Search"
                      className="searchBtn"
                      onClick={getSearchHandler}
                      disabled={loading}
                    />
                    <PR.Button
                      type="reset"
                      label="Reset"
                      className="resetBtn"
                      onClick={getResetHandler}
                      disabled={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="prepaid-table card">
              <PR.DataTable
                loading={loading}
                value={flattenedList}
                stripedRows
                className="vouchers-table"
                expandedRows={expandedRows}
                sortField={sortField}
                sortOrder={sortOrder}
                onSort={onSortChange}
                onRowClick={(e) => {
                  const rowData = e.data;
                  if (!rowData?.vouchers[0]?.vouchersnapshot?.disabled) {
                      setExpandedRows((prevExpandedRows) => {
                          const isAlreadyExpanded = prevExpandedRows?.some(
                              (row) => row?.batchName === rowData?.batchName
                          );
          
                          return isAlreadyExpanded
                              ? prevExpandedRows.filter((row) => row?.batchName !== rowData?.batchName)
                              : [...prevExpandedRows, rowData];
                      });
                  }
                }}
                onRowToggle={(e) => {
                  // Filter out rows where voucher is disabled
                  const validExpandedRows = e.data.filter(
                    (rowData) => !rowData?.vouchers[0]?.vouchersnapshot?.disabled
                  );
                  setExpandedRows(validExpandedRows);
                }}
                rowExpansionTemplate={rowExpansionTemplate}
                rowClassName={(rowData) => {
                  let className = "";
                  if (rowData?.vouchers[0]?.vouchersnapshot?.disabled === true) {
                    className += "disabled-row ";
                  }
                  return className.trim();
                }}

                emptyMessage={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', color: '#888', fontSize: '1.2rem', padding: '2rem', }} >
                  <p>No results found</p>
                </div>
                }
              >
                <PR.Column expander style={{ width: "3%" }} />
                <PR.Column
                  field="batchName"
                  body={batchName}
                  header={renderSortableHeader('Batch Name', 'batchName')}
                  style={{ width: "22%" }}
                ></PR.Column>
                <PR.Column
                  header={renderSortableHeader('Plan', 'description')}
                  body={(rowData) => {
                    const isRowExpanded = expandedRows?.some((row) => row?.batchName === rowData?.batchName); // Check if the row is expanded
                    if (!rowData?.vouchers[0]?.vouchersnapshot?.disabled) {
                      return (
                        <p className="batch-p">
                          <strong>{`${rowData?.redeemed}/${rowData?.total} Vouchers redeemed`}</strong>
                          { !isRowExpanded && ' (Click to expand the detail view of the batch)'}
                        </p>
                      );
                      
                    } else {
                      return (
                        <span className="batch-p">
                          Batch disabled -{" "}
                          {hasPermission(adminData.permission, PERMISSIONS.MANAGE_PROMOS) ? (
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                setDisable(true)
                                setDisableText('Enable Batch')
                                setBatchData(rowData)
                              }}
                              style={{ color: "black", textDecoration: "underline", cursor: "pointer", border: "none" }}
                            >
                              Click here
                            </button>
                          ) : (
                            <span>Contact an admin</span>
                          )}{" "}
                          to enable the batch again
                        </span>
                      );
                    }
                  }}
                  style={{ width: "15%" }}
                />
                <PR.Column
                  header='Bundle ID'
                  style={{ width: "13%" }}
                ></PR.Column>
                <PR.Column
                  header={renderSortableHeader('Duration', 'duration')}
                  style={{ width: "8%" }}
                ></PR.Column>
                <PR.Column
                  header={renderSortableHeader('Data', 'dataAmount')}
                  style={{ width: "8%" }}
                ></PR.Column>
                <PR.Column
                  header={renderSortableHeader('Price', 'ourPrice')}
                  style={{ width: "7%" }}
                ></PR.Column>
                <PR.Column
                  header={renderSortableHeader('Status', 'status')}
                  style={{ width: "8%" }}
                  body={(rowData) => {
                    const isRowExpanded = expandedRows?.some((row) => row?.batchName === rowData?.batchName);
                    return (
                      <div className="batch-s" style={{ userSelect: 'none' }} onClick={(e) => e.stopPropagation()}>
                        { isRowExpanded && rowData?.vouchers?.length > 10 &&
                        <PR.Paginator
                          first={(paginationState[rowData.batchName] || 0) * 10}
                          rows={10}
                          totalRecords={rowData?.vouchers?.length}
                          onPageChange={(event) => onPageChanges(event, rowData.batchName)}
                          template={{ layout: "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink JumpToPageInput",
                            JumpToPageInput: (options) => (
                              <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                  <span className="goto-span">Go to</span>
                                  {options.element}
                              </span>
                          )
                          }}
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"   
                          />
                        }
                      </div>
                    );
                  }}
                ></PR.Column>          
                <PR.Column                
                  header={renderSortableHeader("Voucher Code", "promoCode")}
                  className="voucherCode"
                  style={{ width: "13.3%" }}
                ></PR.Column>
                <PR.Column
                  className="last-column"
                style={{ width: "2%" }}
                ></PR.Column>
              </PR.DataTable>
              {!loading &&
                <div className="pagination">
                  <PR.Button onClick={handlePrevPage} disabled={currentPage === 1}>Prev</PR.Button>
                  <span className="active">{currentPage}</span>
                  <PR.Button onClick={handleNextPage} type="button" disabled={!totalRecords} >Next</PR.Button>
                </div>
              }
              <PR.Dialog
                visible={disable}
                dismissableMask={true}
                draggable={false}
                resizable={false}
                header={disableText === 'Disable Batch' ? 'Disable Batch' : 'Enable Batch'}
                onHide={() => setDisable(false)}
                className="affiliate-dialog"
                maskClassName="affiliate-dialog-mask"
              >
                <p>Are you sure you want to {disableText === 'Disable Batch' ? 'Disable' : 'Enable'} this batch?</p>
                <div className="dialog-footer buttons-sections flex gap-3 align-items-center justify-content-end">
                  <PR.Button onClick={() => setDisable(false)} label="No" className="confirm-button  reset-btn min-width" disabled={batchLoading} />
                  <PR.Button onClick={() => { if (batchData) { updateBatchDisable(batchData, "disable", "main") } }} label="Yes" className="confirm-button min-width" disabled={batchLoading} />
                </div>
              </PR.Dialog>
            </div>
          </section>
        </div>
        <div className="layout-content-wrapper">
          <AdminFooter />
        </div>

        {/* Create Prepaid Vouchers Dialog */}
        <PR.Dialog
          header="Create Prepaid Voucher(s)"
          visible={createVoucher}
          draggable={false}
          resizable={false}
          blockScroll={true}
          onHide={onHideHandler}
          dismissableMask={true}
          maskClassName="create-voucher-dialog-mask"
          className="filter-dialog voucher-modal create-voucher-dialog"
        >
          <form className="filter-content">
            <div className="grid mt-2">
              <div className="col-12 md:col-6">
                <p className="mb-2">Batch Name</p>
                <PR.InputText
                  value={formik.values.batchName}
                  keyfilter={/^[a-zA-Z0-9-_ ]*$/}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Name of the batch"
                  className="w-full"
                  name="batchName"
                  disabled={catalogLoading || createLoading}
                />
                {formik.touched.batchName && formik.errors.batchName && (
                  <small className="p-error">{formik.errors.batchName}</small>
                )}
              </div>
              <div className="col-12 md:col-6">
                <p className="mb-2">Voucher Count</p>
                <PR.InputNumber
                  value={totalVouchers}
                  onChange={(e) => {
                      handleTotalVoucherChange(e);
                  }}
                  onBlur={handleBlur}
                  placeholder="Total Number of Vouchers"
                  min={1}
                  maxLength={4}
                  disabled={catalogLoading || createLoading}
                  className="w-12"
                />
                {(touched || error) && !totalVouchers && (
                    <small className="p-error">{error}</small>
                )}             
                </div>
            </div>
            <div className="grid mt-2">
              <div className="col-12 pb-1">
                <p>Select region & country</p>
              </div>
              <div className="col-12">
                <div className="flex gap-2 w-full align-items-center m-flex">
                  <PR.Dropdown
                    value={selectedRegion}
                    onChange={(e) => handleRegionSelection(e.value)}
                    options={uniqueRegions}
                    optionLabel="label"
                    placeholder="Select region"
                    filter
                    className="w-full"
                    disabled={catalogLoading || createLoading}
                    showClear
                  />
                  <PR.Dropdown
                    value={country}
                    onChange={handleCountrySelection}
                    options={countries}
                    optionLabel="name"
                    optionValue="iso"
                    placeholder="Select country"
                    filter
                    resetFilterOnHide
                    className="w-full"
                    disabled={catalogLoading || createLoading}
                  />
                  <PR.MultiSelect
                    value={provider}
                    onChange={handleProviderSelection}
                    options={providerList}
                    optionLabel="name"
                    placeholder="Select provider"
                    className="w-full"
                    disabled={catalogLoading || createLoading}
                  />
                  <PR.Button
                    label="Search"
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      searchHandler();
                    }}
                    className="search-button"
                    disabled={
                      (!provider.length && !selectedRegion && !country) ||
                      catalogLoading || createLoading
                    }
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="grid mt-2">
                <div className="col-12 pb-1">
                  <p>Select bundle(s)</p>
                </div>
                <div className="col-12">
                  <PR.DataTable
                    loading={catalogLoading || createLoading}
                    value={displayedBundles}
                    className="bundles-table custom-min-height"
                    sortField={createSortField}
                    sortOrder={createSortOrder}
                    onSort={(e) => {
                        const sortDirection = e.sortOrder === 1 ? "asc" : "desc";
                        const sortBy = e.sortField;
                        setCreateSortField(sortBy);
                        setCreateSortOrder(e.sortOrder);
                        getCatalogs(sortBy, sortDirection);
                    }}
                    emptyMessage={<span className="text-gray-500">No results found</span>}
                  >
                    {bundles.length === 0 && (
                      <PR.Column colSpan={1} style={{ textAlign: "center" }}>
                        No records found.
                      </PR.Column>
                    )}
                    <PR.Column body={selectBox} header="Select"></PR.Column>
                    <PR.Column
                      field="description"
                      header="Name of the bundle"
                      body={(rowData) => (rowData?.description ? `${filterCountryName(rowData?.description)}` : "-")}
                    ></PR.Column>
                    <PR.Column
                      field="providerBundleName"
                      header="Bundle ID"
                      body={(rowData) => (
                        rowData?.providerBundleName ? rowData.providerBundleName : '-'
                      )}
                    ></PR.Column>
                    <PR.Column
                      field="dataAmount"
                      header="Data"
                      sortable
                      body={(rowData) => setDataAmount(rowData)}
                    ></PR.Column>
                    <PR.Column
                      field="duration"
                      header="Duration"
                      body={(rowData) => `${rowData?.duration} days`} 
                    ></PR.Column>
                    <PR.Column
                      field="providerName"
                      header="Provider"
                      style={{width:"8%"}}
                    ></PR.Column>
                    {/* <PR.Column
                      header="Roaming" 
                      body={(data) => <RoamingColumn data={data} />}
                    ></PR.Column> */}
                    <PR.Column
                      field="providerPrice"
                      header="Provider Price"
                      sortable
                      style={{width:"12%"}}
                      body={(rowData) => (
                        rowData?.providerPrice ? `${globalConfig.defaultCurrency} ${rowData?.providerPrice}` : '-'
                      )}
                    ></PR.Column>    
                    <PR.Column
                      field="ourPrice"
                      header="Price"
                      sortable
                      body={(rowData) => (
                        rowData?.ourPrice ? `${globalConfig.defaultCurrency} ${rowData?.ourPrice}` : '-'
                      )}
                    ></PR.Column>              
                    <PR.Column
                      body={vouchersInput}
                      header="No. of vouchers"
                      className="last-column"
                      style={{width:"12%"}}
                    ></PR.Column>
                  </PR.DataTable>
                </div>
              </div>
              <div className="buttons-sections flex align-items-center justify-content-between gap-3 mt-3">
                <p></p>
                <div className="flex align-items-center gap-3">
                  <PR.Button
                    label="Reset"
                    type="button"
                    className="confirm-button reset-btn min-width"
                    disabled={createLoading}
                    onClick={resetData}
                  />
                  <PR.Button
                    label="Create"
                    type="submit"
                    className="confirm-button min-width"
                    disabled={!displayBundle || selectedBundles?.length === 0 || createLoading}
                    onClick={handleFormSubmit}
                  />
                </div>
              </div>
            </div>
          </form>
        </PR.Dialog>

        {/* Filter Options Dialog */}
        <PR.Dialog
          header="Filter"
          visible={visible}
          draggable={false}
          resizable={false}
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            position: "absolute",
            margin: "0",
          }}
          onHide={() => setVisible(false)}
          dismissableMask={true}
          className="filter-dialog voucher-modal"
        >
          <form
            autoComplete="off"
            className="mt-0"
            onSubmit={handleFilterSubmit}
          >
            <div className="filter-content">
              <div className="grid">
                <div className="col-12 pb-1">
                  <p>By region or country or provider</p>
                </div>
                <div className="col-12 md:col-4">
                  <PR.Dropdown
                    value={filterSelectedRegion}
                    onChange={(e) => regionFilterHandler(e.value)}
                    options={uniqueRegions}
                    optionLabel="label"
                    placeholder="Select region"
                    filter
                    resetFilterOnHide
                    showClear="true"
                    className="w-full"
                  />
                </div>
                <div className="col-12 md:col-4">
                  <PR.Dropdown
                    value={filterCountry}
                    onChange={countryFilterHandler}
                    options={filterCountries}
                    optionLabel="name"
                    optionValue="iso"
                    placeholder="Select country"
                    showClear={filterCountry ? true : false}
                    filter
                    resetFilterOnHide
                    className="w-full"
                  />
                </div>
                <div className="col-12 md:col-4">
                  <PR.MultiSelect
                    value={filterprovider}
                    onChange={handleProviderFilterSelection}
                    options={providerList}
                    optionLabel="name"
                    placeholder="Select provider"
                    className="w-full"
                  />
                </div>
              </div>
              <div className="grid mt-2">
                <div className="col-12 pb-1">
                  <p>By batch name or created date</p>
                </div>
                <div className="col-12 md:col-6">
                  <PR.Dropdown
                    value={filterBatchName}
                    onChange={(e) => { setFilterBatchName(e.value) }}
                    options={batchOptions}
                    showClear={true}
                    resetFilterOnHide
                    optionLabel="name"
                    placeholder="Select batch"
                    filter
                    className="w-full"
                  />
                </div>
                <div className="col-12 md:col-6">
                  <PR.Calendar
                    value={startDate}
                    selectionMode="range"
                    onChange={(e) => setStartDate(e.value)}
                    dateFormat="dd/mm/yy"
                    maxDate={new Date()}
                    showIcon
                    placeholder="Select date"
                  />
                </div>
              </div>
              <div className="grid mt-2">
                <div className="col-12 pb-1">
                  <p>Voucher status or date redeemed</p>
                </div>
                <div className="col-12 md:col-6">
                  <PR.MultiSelect
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.value)}
                    options={optionStatusList}
                    optionLabel="label"
                    placeholder="Select status"
                    filter
                    className="w-full"
                  />
                </div>
                <div className="col-12 md:col-6">
                  <PR.Calendar
                    value={endDate}
                    selectionMode="range"
                    onChange={(e) => setEndDate(e.value)}
                    dateFormat="dd/mm/yy"
                    showIcon
                    placeholder="Select date"
                    maxDate={new Date()}
                  />
                </div>
              </div>
              <div className="buttons-sections flex align-items-center justify-content-end gap-3">
                <PR.Button
                  label="Reset"
                  type="button"
                  className="confirm-button reset-btn min-width"
                  onClick={handleFilterReset}
                />
                <PR.Button
                  label="Apply"
                  type="submit"
                  className="confirm-button min-width"
                />
              </div>
            </div>
          </form>
        </PR.Dialog>

        {/* Prepaid Vouchers Info Dialog */}
        <PR.Dialog
          header="Prepaid/Retail Voucher Details"
          visible={showBatchInfoDialog}
          draggable={false}
          resizable={false}
          blockScroll={true}
          onHide={() => { setShowBatchInfoDialog(false) ; setCreatedByError(false)}}
          dismissableMask={true}
          maskClassName="create-voucher-dialog-mask"
          className="filter-dialog voucher-modal create-voucher-dialog"
        >
          {selectedInfoBatch && selectedInfoBatch.length > 0 && (
            <div>
              {selectedInfoBatch.map(
                (
                  batch,
                  index // Iterate through each batch
                ) => (
                  <div key={index}>
                    <div className="grid">
                      <div className="col-12 md:col-3">
                        <p className="mb-2">Batch Name</p>
                        <PR.InputText
                          value={batch.name} // Accessing batch name
                          className="w-full"
                          name="batchName"
                          readOnly
                          disabled
                        />
                      </div>
                      <div className="col-12 md:col-3">
                        <p className="mb-2">Voucher Count</p>
                        <PR.InputText
                          value={batch.total} // Accessing total voucher count
                          className="w-full"
                          type="number"
                          name="voucherCount"
                          readOnly
                          disabled
                        />
                      </div>
                      <div className="col-12 md:col-3">
                        <p className="mb-2">Created By</p>
                        <PR.Dropdown
                          value={createdByInfo}
                          options={handleAffiliateOptions(affiliateNames)}
                          onChange={(e) => {
                            setCreatedByInfo(e.value);
                            if (e.value !== null && e.value !== undefined) {
                              setCreatedByError("");
                            }
                          }}
                          onHide={() => {
                            if (createdByInfo === null || createdByInfo === undefined) {
                              setCreatedByError("Created By is required");
                            }
                          }}
                          className="w-full createdby-dropdown"
                          filter 
                          resetFilterOnHide 
                          disabled={disableText === "Enable Batch"}
                        />
                        {createdByError && (
                          <small className="p-error">{createdByError}</small>
                        )}
                      </div>
                      <div className="col-12 md:col-3 buttons-sections m-mt-0">
                        {hasPermission(adminData.permission, PERMISSIONS.MANAGE_PROMOS) && (
                          <PR.Button
                            onClick={() => updateBatchDisable(batch, "affiliate", "aff")}
                            label="Update"
                            className="w-full confirm-button"
                            disabled={disableText === "Enable Batch" || !createdByInfo}
                          />
                        )}
                      </div>
                    </div>

                    <div className="grid mt-2">
                      <div className="col-12 pb-1">
                        <p className="m-0">Bundle(s) Details</p>
                      </div>
                      <div className="col-12">
                        <PR.DataTable
                          value={batch.bundles} // Directly using the bundles array
                          className="bundles-table voucher-details-table"
                          emptyMessage={<span className="text-gray-500">No results found</span>}
                        >
                          <PR.Column
                            field="bundle.description" // Accessing the name of the bundle
                            header="Plan"
                            style={{width:"18%"}}
                            body={(rowData) => (rowData?.bundle.description ?
                              `${filterCountryName(rowData?.bundle.description)}` : '-'
                            )}
                          />
                          <PR.Column
                            header="Bundle Name"
                            style={{width:"10%"}}
                            body={(rowData) => (
                              <div>
                                  <div>{rowData.bundle.name ? rowData.bundle.name : "-"}</div>
                                  <div style={{ marginTop: "4px" }}>
                                  {rowData.bundle.groups ? rowData.bundle.groups : "-"}
                                  </div>
                              </div>
                              )}  
                            />
                          <PR.Column
                            field="bundle.providerid"
                            header="Bundle ID"
                            style={{width:"13%"}}
                            body={(rowData) => (
                              rowData?.bundle.providerid ?
                                rowData?.bundle.providerid : '-'
                            )}
                          />   
                          <PR.Column
                            field="bundle.dataAmount" // Accessing data amount for display
                            header="Data"
                            sortable
                            body={(rowData) => setDataAmount(rowData?.bundle)}
                          />
                          <PR.Column
                            field="bundle.duration" // Accessing duration
                            header="Duration"
                            body={(rowData) => (rowData?.bundle.duration ?
                              `${rowData?.bundle.duration} days` : '-'
                            )}
                          />
                          <PR.Column
                            field="providerName" // Accessing provider name
                            header="Provider"
                            style={{width:"7%"}}
                          />
                          <PR.Column
                            field="bundle.roamingEnabled" // Accessing roaming information
                            header="Roaming"
                            body={(data) => <RoamingColumn data={data} />}
                            style={{width:"12%"}}
                          />
                           <PR.Column
                            field="bundle.providerPrice" // Accessing price
                            header="Provider Price"
                            sortable
                            style={{width:"12%"}}
                            body={(rowData) => (
                              rowData?.bundle.providerPrice ?
                                `${globalConfig.defaultCurrency}
                                ${rowData?.bundle.providerPrice}` : '-'
                            )}
                          />
                          <PR.Column
                            field="bundle.price" // Accessing price
                            header="Price"
                            sortable
                            body={(rowData) => (
                              rowData?.bundle.ourPrice ?
                                `${globalConfig.defaultCurrency}
                                ${rowData?.bundle.ourPrice}` : '-'
                            )}
                          />
                          <PR.Column
                            field="vouchers" // Accessing vouchers for the count
                            body={(data) => data.vouchers.length} // Displaying the number of vouchers
                            header="No. of vouchers"
                            className="last-column"
                            style={{width:"12%"}}
                          />
                        </PR.DataTable>
                      </div>
                      <PR.Dialog
                        visible={disable}
                        dismissableMask={true}
                        draggable={false}
                        resizable={false}
                        header={disableText === 'Disable Batch' ? 'Disable Batch' : 'Enable Batch'}
                        onHide={() => setDisable(false)}
                        className="affiliate-dialog"
                        maskClassName="affiliate-dialog-mask"
                      >
                        <p>Are you sure you want to {disableText === 'Disable Batch' ? 'Disable' : 'Enable'} this batch?</p>
                        <div className="dialog-footer buttons-sections flex gap-3 align-items-center justify-content-end">
                          <PR.Button onClick={() => setDisable(false)} label="No" className="confirm-button reset-btn min-width" disabled={batchLoading} />
                          <PR.Button onClick={() => updateBatchDisable(batch, "disable", "info")} label="Yes" className="confirm-button min-width" disabled={batchLoading} />
                        </div>
                      </PR.Dialog>
                    </div>

                    <div className="buttons-sections mobile-flex flex align-items-center justify-content-between gap-3 mt-3">
                      <div>
                        Created date: {" "}
                        {moment.utc(batch.createdAt).local().format("DD-MM-YY | HH:mm:ss")}
                      </div>

                      <div className="flex align-items-center gap-3">
                        <PR.Button
                          label="Download CSV"
                          type="button"
                          className="confirm-button reset-btn1 min-width"
                          onClick={() => downloadXls(batch)}
                          disabled={disableText === 'Enable Batch'}
                        />
                        {hasPermission(adminData.permission, PERMISSIONS.MANAGE_PROMOS) && (
                          <PR.Button
                            label={disableText}
                            type="button"
                            className="confirm-button batch-btn min-width"
                            onClick={() => setDisable(true)}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          )}
        </PR.Dialog>

       {/* Share Voucher Code Modal Dialog */}
        <PR.Dialog header="Share Voucher Code" visible={shareVoucher} onHide={handleHide} draggable={false} resizable={false} blockScroll={true}
        maskClassName="create-voucher-dialog-mask" className="filter-dialog voucher-modal create-voucher-dialog share-voucher-dialog">
        <div className="voucher-code-content">
          <h2>{voucherCode?.code}</h2>
          <div className="grid">
            <div className="col-12 md:col-12">
              <p className="mb-2">Enter the email address you want to share the code</p>
              <PR.InputText
                className="w-full"
                name="email"
                value={email}
                onBlur={handleBlur}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="example@domain.com"
              />
              {emailError && <small className="p-error">{emailError}</small>}
            </div>
            <div className="buttons-sections col-12 flex gap-3 align-items-center justify-content-end mt-2">
              <PR.Button
                label="Reset"
                className="confirm-button reset-btn"
                onClick={handleReset}
                disabled={isLoading}
              />
              <PR.Button
                label="Send"
                className="confirm-button create"
                onClick={handleSend}
                loading={isLoading}
              />
            </div>
          </div>
        </div>
      </PR.Dialog>

        <PR.Toast ref={toast} position="top-right" />
      </div>
    </>
  );
};

export default PrepaidRetailVouchers;
